export const GET_NOMINATIONS = '/api/Nomination/GetNominationByGasDay';
export const POST_NOMINATIONS = '/api/Nomination/PostNominationByGasDay';
export const DOWNLOAD_NOMINATIONS = '/api/Nomination/Download';
export const GET_REJECTED_NOMINATIONS = '/api/Nomination/search';
export const GET_MATCHING_AND_SCHEDULING_NOMINATIONS =
  '/api/MatchingScheduling/GetMatchingSchedulingData';
export const DOWNLOAD_MATCHING_AND_SCHEDULING =
  '/api/MatchingScheduling/Download';
export const GET_SYNC_NOMS_DATA_FROM_GEMINI =
  '/api/MatchingScheduling/SyncNomsDataFromGemini';
export const GET_NOMINATIONS_HISTORY =
  '/api/Nomination/GetNominationHistoryByGasDay';
export const GET_TRADE_MATCHING_STATUS =
  '/api/TradeMatchingStatus/GetTradeMatchingStatus';
export const DOWNLOAD_TRADE_MATCHING_STATUS =
  '/api/TradeMatchingStatus/Download';
export const GET_NOMINATION_COUNTS = '/api/Nomination/counts';
export const GET_LATEST_NOMINATION_FROM_GEMINI =
  '/api/Nomination/refresh-nominations';

// for dashboard
export const GET_NOMINATION_STATUS = '/api/Nomination/Status';

export const GET_BEACH_POSITIONS = 'api/BeachPosition/GetBeachPosition';
